module.exports = __webpack_public_path__ + "img/br.950f8266.png";